import React from "react";
import {
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Home as HomeIcon,
  Settings as SettingsIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import BarChartIcon from '@mui/icons-material/BarChart';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import { useDispatch } from "react-redux";
import { logout } from "../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { useUser } from '../../contexts/UserContext';

const Sidebar = ({
  isOpen,
  toggleSidebar,
  setShowAnalytics,
  setShowCandidateStats,
  handleAnalytics,
}) => {
  const { role } = useUser();
  const [list, setList] = React.useState("home");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleClick = (id) => {
    switch (id) {
      case "home":
        navigate("/dashboard");
        handleAnalytics(false);
        break;
      case "operator":
        navigate("operators");
        handleAnalytics(false);
        break;
      case "analytics":
        navigate("/dashboard");
        handleAnalytics(true);
        break;
      case "CsrReport":
        navigate("CsrReport");
        break;
      case "TableStatic":
        navigate("TableStatic");
        break;
      case "settings":
        navigate("/dashboard/settings");
        break;
      default:
        break;
    }
  };

  const baseItems = [
    {
      id: "home",
      icon: <HomeIcon htmlColor="#605d5d" />,
      iconDark: <HomeIcon htmlColor="#fff" />,
      text: "Dashboard",
    },
    {
      id: "operator",
      icon: <SettingsIcon htmlColor="#605d5d" />,
      iconDark: <SettingsIcon htmlColor="#fff" />,
      text: "Operator",
    },
  ];

  const adminItems = [
    {
      id: "analytics",
      icon: <BarChartIcon htmlColor="#605d5d" />,
      iconDark: <BarChartIcon htmlColor="#fff" />,
      text: "Analytics",
    },
    {
      id: "CsrReport",
      icon: <AssignmentLateIcon htmlColor="#605d5d" />,
      iconDark: <AssignmentLateIcon htmlColor="#fff" />,
      text: "CSR Report",
    },
    {
      id: "TableStatic",
      icon: <EqualizerIcon htmlColor="#605d5d" />,
      iconDark: <EqualizerIcon htmlColor="#fff" />,
      text: "TableStatic",
    },
    {
      id: "settings",
      icon: <SettingsIcon htmlColor="#605d5d" />,
      iconDark: <SettingsIcon htmlColor="#fff" />,
      text: "Settings",
    },
  ];

  const logoutItem = {
    id: "logout",
    icon: <LogoutIcon htmlColor="#605d5d" />,
    iconDark: <LogoutIcon htmlColor="#fff" />,
    text: "Logout",
  };

  const sideBarItems = [...baseItems, ...(role === "admin" ? adminItems : []), logoutItem];
  console.log(role);
  return (
    <Drawer
      variant="permanent"
      open={true}
      sx={{
        "& .MuiDrawer-paper": {
          width: isOpen ? 240 : 60,
          transition: "width 0.3s ease",
          overflowX: "hidden",
          padding: 2,
          backgroundColor: "#ffffff",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: isOpen ? "space-between" : "center",
          padding: "8px",
          height: "64px",
        }}
      >
        {isOpen && (
          <Typography sx={{ lineHeight: 0 }} color="inherit">
            <img src="/assets/icons/logo.jpeg" width={58} height={75} alt="Logo" />
          </Typography>
        )}
        <IconButton color="inherit" onClick={toggleSidebar}>
          <MenuIcon />
        </IconButton>
      </Box>

      <List
        sx={{
          height: "91vh",
          position: "relative",
          paddingTop: 4,
          backgroundColor: "#ffffff",
        }}
      >
        {sideBarItems.map((item, index) => (
          <div
            key={index}
            onMouseOver={() => setList(item.id)}
            onMouseLeave={() => setList("")}
          >
            <ListItem
              button
              sx={{
                ":hover": {
                  backgroundColor: item.id === "logout" ? "#de0202" : "#1976d2",
                  color: "white",
                },
                backgroundColor: list === item.id ? "#1976d2" : "",
                color: list === item.id ? "white" : "",
                borderRadius: 4,
                cursor: "pointer",
                marginBottom: 2,
                position: item.id === "logout" ? "absolute" : "relative",
                bottom: item.id === "logout" ? 32 : "auto",
              }}
              onClick={() => {
                if (item.id === "logout") {
                  handleLogout();
                } else {
                  handleClick(item.id);
                }
              }}
            >
              <ListItemIcon sx={{ color: "#dadada", minWidth: 42 }}>
                {list === item.id ? item.iconDark : item.icon}
              </ListItemIcon>
              {isOpen && <ListItemText primary={item.text} />}
            </ListItem>
          </div>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;
